import(/* webpackMode: "eager" */ "/var/www/safiruni/front/app/[lang]/(AUTH)/login/page.tsx");
